import { useState, useEffect } from "react";

function PermisoFormModal({ isOpen, onClose, permisoData, onSubmit }) {
  const isEdit = !!permisoData;

  const [form, setForm] = useState({
    descripcion: "",
  });

  useEffect(() => {
    if (isOpen) {
      setForm({
        descripcion: permisoData?.descripcion || "",
      });
    }
  }, [isOpen, permisoData]);

  const updateField = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const submit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <div className="modal-overlay">
      <style>{styles}</style>

      <div className="modal-card">
        <h2 className="modal-title">
          {isEdit ? "Edit Permission" : "Create Permission"}
        </h2>

        <form onSubmit={submit} className="modal-form">

          <label className="form-label">Description</label>
          <input
            name="descripcion"
            value={form.descripcion}
            onChange={updateField}
            required
            className="form-input"
            placeholder="Enter permission name..."
          />

          <div className="modal-buttons">
            <button type="submit" className="btn-primary">
              {isEdit ? "Save Changes" : "Create Permission"}
            </button>

            <button type="button" onClick={onClose} className="btn-cancel">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = `
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex;
  justify-content: center;
  align-items: center;

  /* Por encima del sidebar, que esta en 3001. Con 3000 el sidebar se pinta
     encima del modal. */
  z-index: 4100;
}
.modal-card {
  width: 420px;
  background: white;
  padding: 26px;
  border-radius: 14px;
  box-shadow: 0 8px 28px rgba(0,0,0,0.12);
  font-family: 'Segoe UI';
  animation: fadeIn 0.18s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.96); }
  to   { opacity: 1; transform: scale(1); }
}

.modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #1E3A5F;
  margin-bottom: 16px;
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #475569;
}

.form-input {
  width: 93%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #CBD5E1;
  font-size: 14px;
  background: #F8FAFC;
  color: #1E293B;
  transition: 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: #3B82F6;
  background: white;
}

.modal-buttons {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.btn-primary {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  background: #3B82F6;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: 0.22s;
}

.btn-primary:hover {
  background: #2563EB;
}

.btn-cancel {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  background: #E2E8F0;
  color: #475569;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: 0.22s;
}

.btn-cancel:hover {
  background: #CBD5E1;
}
`;

export default PermisoFormModal;
